import { AcademicLevel, Campus, Email, FirstName, LastName, MobilePhoneRequired, Consentement, WishedProgramm } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...WishedProgramm,
  })
})

export default schema


